// @todo maybe we should use this?

const throttle = (fn, delay) => {
  // capture the current time
  let time = Date.now();

  return () => {
    if (time + delay - Date.now() <= 0) {
      // Run the function we've passed to our throttler,
      // and reset the `time` variable (so we can check again).
      fn();
      time = Date.now();
    }
  };
};

export default throttle;
